import * as types from '../mutation-types'

const moduleCadastroProduto = {
	state: {
		cadastroProduto: {}
	},
	getters: {
        cadastroProduto: state => { return state.cadastroProduto.codigo ?  state.cadastroProduto : false},
	},
	mutations: {
        [types.ADD_CADASTRO_PRODUTO](state, cadastroProduto) { state.cadastroProduto = cadastroProduto },
	},
	actions: {
		addcadastroProduto({ commit }, cadastroProduto) {
			commit(types.ADD_CADASTRO_PRODUTO, cadastroProduto)
		},
	},
}
export default moduleCadastroProduto